import { render, staticRenderFns } from "./ReportEditWorkTypes.vue?vue&type=template&id=cc6b6618&scoped=true&"
import script from "./ReportEditWorkTypes.vue?vue&type=script&lang=js&"
export * from "./ReportEditWorkTypes.vue?vue&type=script&lang=js&"
import style0 from "./ReportEditWorkTypes.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReportEditWorkTypes.vue?vue&type=style&index=1&id=cc6b6618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6b6618",
  null
  
)

export default component.exports
import {QBtn,QDialog,QCard,QCardSection,QItem,QBtnGroup,QTooltip,QTh,QTd,QCheckbox,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QBtn,QDialog,QCard,QCardSection,QItem,QBtnGroup,QTooltip,QTh,QTd,QCheckbox,QSeparator,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
